import React, { useEffect } from "react";

const Security = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="px-4 sm:px-32 pt-4 sm:pt-28">
      <h1 className="text-3xl font-bold mb-12">Security Practices</h1>
      <h2 className="text-xl mt-8 mb-3 font-semibold">VM Security:</h2>
      <p className="mb-6">
        Our VM instances adhere to the following security best practices and
        baselines:
      </p>
      <h2 className="text-xl mt-8 mb-3 font-semibold">
        Instance Configuration
      </h2>
      <p className="mb-6">
        AMI Selection: We use Amazon Machine Images (AMIs) that are up-to-date
        and have the latest security patches applied.
      </p>
      <p className="mb-6">
        Instance Type: We choose instance types that provide the necessary
        resources while minimizing exposure to security vulnerabilities.
      </p>
      <p className="mb-6">
        Security Groups: We configure security groups to restrict inbound and
        outbound traffic to only what is necessary for the application.
      </p>
      <p className="mb-6">
        IAM Roles: We assign IAM roles to VM instances to provide the necessary
        permissions while adhering to the principle of least privilege.
      </p>
      <h2 className="text-xl mt-8 mb-3 font-semibold">Network Security</h2>
      <p className="mb-6">
        {`VPC Configuration: We deploy VM instances within a Virtual Private Cloud
        (VPC) to isolate them from other networks.`}
      </p>
      <p className="mb-6">
        Subnetting: We use subnets to segment the network and apply different
        security controls to different parts of the infrastructure.
      </p>
      <p className="mb-6">
        NACLs: We use Network Access Control Lists (NACLs) to provide an
        additional layer of security at the subnet level.
      </p>
      <h2 className="text-xl mt-8 mb-3 font-semibold">
        {" "}
        Monitoring and Logging
      </h2>
      <p className="mb-6">
        CloudWatch: We use Amazon CloudWatch to monitor the performance and
        health of VM instances and to set alarms for abnormal behavior.
      </p>
      <p className="mb-6">
        CloudTrail: We use AWS CloudTrail to log and monitor API calls made to
        the AWS infrastructure, providing an audit trail of changes and access.
      </p>

      <h2 className="text-xl mt-8 mb-3 font-semibold"> Data Security</h2>
      <p className="mb-6">
        EBS Encryption: We use Amazon Elastic Block Store (EBS) encryption to
        protect data at rest on VM instances.
      </p>
      <p className="mb-6">
        Data Backup: We implement regular data backup strategies to ensure data
        recovery in case of incidents.
      </p>

      <h2 className="text-xl mt-8 mb-3 font-semibold">
        Network Security Measures
      </h2>
      <p className="mb-6">
        Our networking is secured with the following measures:
      </p>
      <p className="mb-6">
        DNS Security DNSSEC: We enable DNSSEC to protect against DNS spoofing
        and ensure the integrity of DNS responses.
      </p>
      <p className="mb-6">
        CNAME Flattening: We use CNAME flattening to prevent exposure of
        subdomain structures and reduce the risk of DNS attacks.
      </p>

      <h2 className="text-xl mt-8 mb-3 font-semibold">DDOS Protection</h2>

      <p className="mb-6">
        Rate Limiting: We implement rate limiting to prevent abuse and mitigate
        DDoS attacks.
      </p>
      <p className="mb-6">
        Anycast Network: Cloudflare's Anycast network distributes traffic across
        multiple data centers, providing resilience against DDoS attacks.
      </p>

      <h2 className="text-xl mt-8 mb-3 font-semibold">{`Web Application Firewall (WAF)`}</h2>

      <p className="mb-6">
        Rule Sets: We configure WAF rule sets to protect against common web
        vulnerabilities such as SQL injection, cross-site scripting (XSS), and
        cross-site request forgery (CSRF).
      </p>
      <p className="mb-6">
        Custom Rules: We create custom WAF rules to address specific security
        concerns and protect against targeted attacks.
      </p>

      <h2 className="text-xl mt-8 mb-3 font-semibold">SSL/TLS Encryption</h2>

      <p className="mb-6">
        HTTPS: We enforce HTTPS to ensure secure communication between clients
        and our servers.
      </p>
      <p className="mb-6">
        SSL/TLS Settings: We configure SSL/TLS settings to use strong encryption
        protocols and ciphers.
      </p>

      <h2 className="text-xl mt-8 mb-3 font-semibold">
        Performance and Reliability
      </h2>

      <p className="mb-6">
        CDN: We leverage Cloudflare's Content Delivery Network (CDN) to improve
        the performance and availability of our services.
      </p>
      <p className="mb-6">
        Load Balancing: We use Cloudflare's load balancing to distribute traffic
        across multiple servers, ensuring high availability and resilience.
      </p>
    </div>
  );
};

export default Security;
